import {
  EmailIcon,
  SportsIcon,
  ProductAddIcon,
  PersonAddIcon,
  ChatIcon,
  OrderDraftFilledIcon,
  PaymentFilledIcon,
  WrenchIcon,
} from "@shopify/polaris-icons";

const config = (cms) => {
  return {
    "/": [
      {
        caption: cms("common.actions.dashboard.caption.activity"),
        label: cms("common.actions.dashboard.label.activity"),
        link: "/activity",
        icon: SportsIcon,
      },
      {
        caption: cms("common.actions.dashboard.caption.addProducts"),
        label: cms("common.actions.dashboard.label.addProducts"),
        link: "/products/add",
        icon: ProductAddIcon,
      },
      {
        caption: cms("common.actions.dashboard.caption.addVendors"),
        label: cms("common.actions.dashboard.label.addVendors"),
        link: "/providers/add",
        icon: PersonAddIcon,
      },
      {
        caption: cms("common.actions.dashboard.caption.contactUs"),
        label: cms("common.actions.dashboard.label.contactUs"),
        link: "/contact-us",
        icon: ChatIcon,
      },
    ],
    "/activity": [
      {
        caption: cms("common.actions.activity.caption.bulk"),
        label: cms("common.actions.activity.label.bulk"),
        link: "/activity/bulk",
        icon: SportsIcon,
      },
    ],
    "/invitation": [
      {
        caption: cms("common.actions.invitation.caption.invite"),
        label: cms("common.actions.invitation.label.invite"),
        link: "/providers/add",
        icon: EmailIcon,
      },
    ],
    "/orders": [
      {
        caption: cms("common.actions.orders.caption.settings"),
        label: cms("common.actions.orders.caption.label"),
        link: "/setting/order",
        icon: OrderDraftFilledIcon,
      },
    ],
    "/payments": [
      {
        caption: cms("common.actions.payments.caption.autoPayouts"),
        label: cms("common.actions.payments.label.autoPayouts"),
        link: "/payouts",
        icon: PaymentFilledIcon,
      },
    ],
    "/products": [
      {
        caption: cms("common.actions.products.caption.addProductStore"),
        label: cms("common.actions.products.label.addProductStore"),
        link: "/products/add",
        icon: ProductAddIcon,
      },
      {
        caption: cms("common.actions.products.caption.review"),
        label: cms("common.actions.products.label.review"),
        link: "/setting/product",
        icon: WrenchIcon,
      },
    ],
    "/providers": [
      {
        caption: cms("common.actions.vendors.caption.add"),
        label: cms("common.actions.vendors.label.add"),
        link: "/providers/add",
        icon: "",
      },
      {
        caption: cms("common.actions.vendors.caption.vendorPage"),
        label: cms("common.actions.vendors.label.vendorPage"),
        link: "/advance-providers",
        icon: "",
      },
    ],
  };
};

export default config;
